@let isFreeSlot = slot().slotType === 'free';
@let isMandatorySlot = slot().slotType === 'mandatory';
<ng-template #freeHeader let-expanded="expanded">
  <div class="wrapper-free-header">
    <div class="wrapper-title">
      <ui-icon class="gift-icon" faName="gift" faStyle="light"></ui-icon>
      <span>{{ description() }}</span>
    </div>

    <ui-icon [faName]="expanded ? 'chevron-up' : 'chevron-down'" faStyle="solid"></ui-icon>
  </div>
</ng-template>

<div [class.free-slot]="isFreeSlot">
  <ui-expander [title]="description()" [headerTemplate]="isFreeSlot ? freeHeader : undefined">
    <div class="slot-item-grid">
      @for (item of slot().products; track item.sku; let index = $index) {
        @let productState = slotState().itemMap.get(item.sku);
        @let max = isFreeSlot ? (productState?.quantity ?? 0) + currentThreshold() - slotState().selectedAmount : undefined;

        <ui-configurable-bundle-form-item
          (amountChange)="amountChanged($event,item.sku)"
          (removeFromBundle)="removeFromBundle($event)"
          (addToBundle)="addToBundle($event)"
          [position]="index"
          [isFree]="isFreeSlot"
          [amount]="productState?.quantity ?? 0"
          [item]="item"
          [showAddToBundle]="showAddToBundle()"
          [showItemQuantity]="isMandatorySlot"
          [maxQuantity]="max"
          [disabled]="cardsDisabled()"
          [isInBundle]="!!productState"
        >

        </ui-configurable-bundle-form-item>
      }
    </div>
  </ui-expander>
</div>
